import React, { useState, useEffect } from 'react';
import './App.css';
import ContentSection from './components/ContentSection';
import { loadContent, saveContent } from './api/contentApi';

function App() {
  const [content, setContent] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    loadContent().then(setContent);
  }, []);

  const handleContentChange = async (sectionId, newContent) => {
    const updatedContent = {
      ...content,
      [sectionId]: newContent
    };
    setContent(updatedContent);
    await saveContent(sectionId, newContent);
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>Shelly at the Calvert Salon Demo and Draft</h1>
        <button 
          className="edit-toggle"
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? 'Exit Edit Mode' : 'Edit Mode'}
        </button>
      </header>

      <main className="app-main">
        <ContentSection
          id="hero"
          type="text"
          content={content.hero || "Welcome to your website! This is the demo version created to highlight the ease of use in editing."}
          isEditing={isEditing}
          onChange={(newContent) => handleContentChange('hero', newContent)}
        />
        
        <ContentSection
          id="about-image"
          type="image"
          content={content.aboutImage || "https://via.placeholder.com/600x400?text=About+Image"}
          isEditing={isEditing}
          onChange={(newContent) => handleContentChange('aboutImage', newContent)}
        />
        
        <ContentSection
          id="about-text"
          type="text"
          content={content.aboutText || "Shelly was born and raised in Lincoln. She has been doing hair since 2008 and started out as a stylist at Cost Cutters. She worked her way up to salon manager and trainer within the compnay. In 2022, Shelly decided to leave Cost Cutters and start her own business."}
          isEditing={isEditing}
          onChange={(newContent) => handleContentChange('aboutText', newContent)}
        />
        
        <ContentSection
          id="services"
          type="text"
          content={content.services || "Since starting her own business, Shelly has developed the motto that 'Everyone deserves a haircut.' So, she offers a variety of services at her salon and she travels to different facilities and homes of people who would otherwise not be able to get hair services. She has experiece with demnentia and alzheimers patients. She also serves individuals with developmental handicaps."}
          isEditing={isEditing}
          onChange={(newContent) => handleContentChange('services', newContent)}
        />
        
        <ContentSection
          id="contact-image"
          type="image"
          content={content.contactImage || "https://scontent.flnk2-1.fna.fbcdn.net/v/t39.30808-6/474587562_581594914675058_1377344997642020788_n.jpg?stp=dst-jpg_s960x960_tt6&_nc_cat=103&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=vA37mr-mWzcQ7kNvwHUGRA9&_nc_oc=Adm9VG4nw24jIOlkPvunw56syWUxFZaUrQO7gftJFMbS1qaj_0Cv-yI4h61PIyQBrc4&_nc_zt=23&_nc_ht=scontent.flnk2-1.fna&_nc_gid=aMwKnq6-bEc7EAWL97vJJg&oh=00_AfZClk8qfCg2vkC0F6K-J2UgpEwbuxr-IuUXPffqZ5By7g&oe=68BFE051"}
          isEditing={isEditing}
          onChange={(newContent) => handleContentChange('contactImage', newContent)}
        />
      </main>

      <footer className="app-footer">
        <ContentSection
          id="footer"
          type="text"
          content={content.footer || "© 2025 Shelly at the Calvert Salon. All rights reserved."}
          isEditing={isEditing}
          onChange={(newContent) => handleContentChange('footer', newContent)}
        />
      </footer>
    </div>
  );
}

export default App;
